<template>
  <div class="sale_img">
    <img :src="item.icon" class="wow animate__animated animate__bounceInRight" :data-wow-delay ="item.time+'s'" :class="'img_'+index" alt="" v-for="(item,index) in imagesList" :key="index+'_so_img'">
  </div>
</template>

<script>
import {WOW} from 'wowjs'
export default {
    name: '',
    props: {
        
    },
    data(){
        return{
            imagesList:[
                {icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/9.png',time:0.2},
                {icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/10.png',time:0.6},
                {icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/11.png',time:1.2},
                {icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/12.png',time:1.6},
            ],
        }
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    methods:{
        
    }
}
</script>

<style scoped  lang="scss">
    .sale_img{
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .img_0{
            position: absolute;
            left: 0;
            top: 6rem;
            z-index: 1;
        }
        .img_1{
            position: absolute;
            left: 12rem;
            top: 6rem;
            z-index: 2;
        }
        .img_2{
            position: absolute;
            left: 24rem;
            top: 6rem;
            z-index: 3;
        }
        .img_3{
            position: absolute;
            left: 38rem;
            top: 6rem;
            z-index: 4;
        }
    }
</style>
